var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.73223 2.06524C4.20107 1.5964 4.83696 1.33301 5.5 1.33301H12.1667C12.3877 1.33301 12.5996 1.42081 12.7559 1.57709L17.7559 6.57709C17.9122 6.73337 18 6.94533 18 7.16634V17.1663C18 17.8294 17.7366 18.4653 17.2678 18.9341C16.7989 19.4029 16.163 19.6663 15.5 19.6663H5.5C4.83696 19.6663 4.20107 19.4029 3.73223 18.9341C3.26339 18.4653 3 17.8294 3 17.1663V3.83301C3 3.16997 3.26339 2.53408 3.73223 2.06524ZM5.5 2.99967C5.27899 2.99967 5.06702 3.08747 4.91074 3.24375C4.75446 3.40003 4.66667 3.61199 4.66667 3.83301V17.1663C4.66667 17.3874 4.75446 17.5993 4.91074 17.7556C5.06702 17.9119 5.27899 17.9997 5.5 17.9997H15.5C15.721 17.9997 15.933 17.9119 16.0893 17.7556C16.2455 17.5993 16.3333 17.3874 16.3333 17.1663V7.51152L11.8215 2.99967H5.5Z",
    fill: "#292B2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1666 1.33301C12.6268 1.33301 12.9999 1.7061 12.9999 2.16634V6.33301H17.1666C17.6268 6.33301 17.9999 6.7061 17.9999 7.16634C17.9999 7.62658 17.6268 7.99967 17.1666 7.99967H12.1666C11.7063 7.99967 11.3333 7.62658 11.3333 7.16634V2.16634C11.3333 1.7061 11.7063 1.33301 12.1666 1.33301Z",
    fill: "#292B2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33325 11.3333C6.33325 10.8731 6.70635 10.5 7.16659 10.5H13.8333C14.2935 10.5 14.6666 10.8731 14.6666 11.3333C14.6666 11.7936 14.2935 12.1667 13.8333 12.1667H7.16659C6.70635 12.1667 6.33325 11.7936 6.33325 11.3333Z",
    fill: "#161719"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33325 14.6663C6.33325 14.2061 6.70635 13.833 7.16659 13.833H13.8333C14.2935 13.833 14.6666 14.2061 14.6666 14.6663C14.6666 15.1266 14.2935 15.4997 13.8333 15.4997H7.16659C6.70635 15.4997 6.33325 15.1266 6.33325 14.6663Z",
    fill: "#161719"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33325 8.00033C6.33325 7.54009 6.70635 7.16699 7.16659 7.16699H8.83325C9.29349 7.16699 9.66659 7.54009 9.66659 8.00033C9.66659 8.46056 9.29349 8.83366 8.83325 8.83366H7.16659C6.70635 8.83366 6.33325 8.46056 6.33325 8.00033Z",
    fill: "#161719"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileText);
export default __webpack_public_path__ + "static/media/file-text.aaf6a987a681a91a9fec853de11d2687.svg";
export { ForwardRef as ReactComponent };